import { withCompInfo } from '../../core/withCompInfo'
import { CustomElementComponentDefinition } from './types'

export const props = withCompInfo<{}, CustomElementComponentDefinition>(
	['compData'],
	({ compData: { tagName, url, initialAttributes, hostedInCorvid } }) => {
		return { tagName, url, initialAttributes, hostedInCorvid }
	}
)
